import { lazy } from 'react';

// ----------------------------------------------------------------------

const OrderViewPage = lazy(
  () =>
    import(
      /* webpackPreload: true */
      /* webpackChunkName: "OrderViewPage" */
      '@/pages/orders/order-view/OrderViewPage'
    ),
);

export default OrderViewPage;
